import React, { useState, useRef, useMemo, useEffect } from "react";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { CartPriceEditAddForm } from "./CartPriceEditAddForm";
import { useSnackbar } from "notistack";

import { Link } from "react-router-dom";
import { ModalProgressBar } from "../../../_metronic/_partials/controls";
import { useSubheader } from "../../../_metronic/layout";
import { createCartPricing, fetchSingleCart, updateCartPricing } from "../../../actions/cart-pricing/cart";

export function CartPriceEdit({
  history,
  match: {
    params: { id },
  },
}) {

  const { enqueueSnackbar } = useSnackbar();

 
  const initCartInfo = {
    plan_name: "",
    plan_type:"",
    plan_desc: "",
    plan_price:"",
    inventory_type:"",
    plan_inventory:""

  };

  const { cartForEdit } = useSelector(
    (state) => ({
      cartForEdit: id ? state.cartPricing?.cartForEdit : undefined,
    }),
    shallowEqual
  );

  // Subheader
  const suhbeader = useSubheader();

  // Tabs
  const [tab, setTab] = useState("basic");
  const [title, setTitle] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!id) {
      suhbeader.setBreadcrumbs([{pathname:'/cart-price', title:'Cart Price'},{pathname:'', title:'Add Cart Price'}]);
    } else {
      suhbeader.setBreadcrumbs([{pathname:'/cart-price', title:'Cart Price'},{pathname:'', title:'Edit Cart Price'}]);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useMemo(async () => {
    if (id === undefined) {
      return;
    }

   dispatch(fetchSingleCart(id));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, dispatch]);

  // set Title
  useMemo(() => {
    let _title = id ? "" : "Add Cart Price";
    suhbeader.setTitle(_title);
    setTitle(_title);

    if (id) {
      _title = "Edit Cart Price";
      setTitle(_title);
      suhbeader.setTitle(_title);
    }
    return {
      _title,
    };
  }, [id, suhbeader]);

  const saveCart = (values) => {
    setIsLoading(true);
    if (!id) {
      dispatch(createCartPricing(values)).then(async (data) => {
        if (data.payload.status) {
          if (data && data.payload) {
            await history.push(`/cart-price`);

            await enqueueSnackbar(data.payload.message, {
              variant: "success",
              autoHideDuration: 4500,
            });
            setIsLoading(false);
          }
        } else {
          await enqueueSnackbar(data.payload.message, {
            variant: "error",
            autoHideDuration: 4500,
          });
          setIsLoading(false);
        }
      });
    } else {
      dispatch(updateCartPricing(values, id)).then(async (data) => {
        if (data.payload.status) {
          if (data && data.payload) {
            await history.push(`/cart-price`);
            await enqueueSnackbar(data.payload.message, {
              variant: "success",
              autoHideDuration: 4500,
            });

            setIsLoading(false);
          }
        } else {
          await enqueueSnackbar(data.payload.message, {
            variant: "error",
            autoHideDuration: 4500,
          });

          setIsLoading(false);
        }
      });
    }
  };

  const btnRef = useRef();
  const saveCartButtonClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  const backToList = () => {
    history.push(`/cart-price`);
  };

  return (
    <Card>
      {false && <ModalProgressBar />}

      <CardHeader title={title}>
        <CardHeaderToolbar>
          <button
            type='button'
            onClick={backToList}
            className='btn btn-light'>
            <i className='fa fa-arrow-left'></i>
            Back
          </button>
          {`  `}

          {`  `}
          <button
            type='submit'
            className='btn btn-primary ml-2'
            disabled={isLoading}
            onClick={saveCartButtonClick}>
              {isLoading ? "Saving..." : "Save"}
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <ul className='nav nav-tabs nav-tabs-line ' role='tablist'>
          <li className='nav-item' onClick={() => setTab("basic")}>
            <Link
              to={history.location.pathname}
              className={`nav-link ${tab === "basic" && "active"}`}
              data-toggle='tab'
              role='tab'
              aria-selected={(tab === "basic").toString()}>
              Basic info
            </Link>
          </li>
        </ul>
        <div className='mt-5'>
          {tab === "basic" && (
            <CartPriceEditAddForm
              cart = {cartForEdit || initCartInfo}
              id={id}
              btnRef={btnRef}
              saveCart={saveCart}
            />
          )}
          {/* If you add new tab than add more */}
        </div>
      </CardBody>
      <hr />
      <CardHeader title=''>
        <CardHeaderToolbar>
          <button
            type='button'
            onClick={backToList}
            className='btn btn-light'>
            <i className='fa fa-arrow-left'></i>
            Back
          </button>
          {`  `}

          {`  `}
          <button
            type='submit'
            className='btn btn-primary ml-2'
            disabled={isLoading}
            onClick={saveCartButtonClick}>
              {isLoading ? "Saving..." : "Save"}
          </button>
        </CardHeaderToolbar>
      </CardHeader>
    </Card>
  );
}
